const apiHost = process.env.NEXT_PUBLIC_API_HOST;
if (!apiHost) {
  throw new Error("NEXT_PUBLIC_API_HOST environment variable is required");
}

export const config = {
  apiHost,
  corsAllowedOrigins: process.env.CORS_ALLOWED_ORIGINS?.split(",") ?? [],
  isLocalDemo: process.env.IS_LOCAL_DEMO === "true",
  isLocalFake: process.env.IS_LOCAL_FAKE === "true",
};
